import "./community_img.css";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { useMediaQuery } from "react-responsive";

function Community_img() {
  const Mobile = useMediaQuery({ maxWidth: 760 });

  const Tab = useMediaQuery({ minWidth: 760 });
  return (
    <>
      <div className="container-fluid mt-5 pt-5">
        {Tab && (
          <div className="community_tit text-center">
            <div className="row mt-5">
              <div className="col-12">
                <div className="community mt-3 pt-4">
                  <h1 className="cmty_title">Our Community</h1>
                </div>

                <div className="d-flex flex-row our_community">
                  <div className="col-4 mt-5">
                    <h1 className="cmty_turf mt-5">
                      <CountUp end={500} redraw={true}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>{" "}
                      +
                    </h1>
                    <br></br>
                    <h3 className="cmty_txt">Turfs</h3>
                  </div>
                  <div className="col-4 mt-5">
                    <h1 className="cmty_playhours mt-5">
                      <CountUp end={10} redraw={true}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      m +
                    </h1>
                    <br></br>
                    <h3 className="cmty_txt">Play Hours</h3>
                  </div>
                  <div className="col-4 mt-5">
                    <h1 className="cmty_users mt-5">
                      {" "}
                      <CountUp end={6} redraw={true}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      k +
                    </h1>
                    <br></br>
                    <h3 className="cmty_txt">Users</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {Mobile && (
          <>
            <div className="community_tit text-center">
              <div className="row mt-5">
                <div className="col-12">
                  <div className="community mt-3 pt-4">
                    <h1 className="cmty_title">Our Community</h1>
                  </div>

                  <div className="d-flex flex-row our_community">
                    <div className="col-4 mt-5">
                      <h1 className="cmty_turf mt-5">
                        <CountUp end={500} redraw={true}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>{" "}
                        +
                      </h1>
                      <br></br>
                      <h3 className="cmty_txt">Turfs</h3>

                    </div>
                    <div className="col-4 mt-5">
                      <h1 className="cmty_playhours mt-5">
                        <CountUp end={10} redraw={true}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                        m +
                      </h1>

                      <br></br>
                      <h3 className="cmty_txt">Play Hours</h3>

                    </div>
                    <div className="col-4 mt-5">
                      <h1 className="cmty_users mt-5">
                        {" "}
                        <CountUp end={6} redraw={true}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                        k +
                      </h1>

                      <br></br>
                      <h3 className="cmty_txt">Users</h3>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Community_img;
